import { render } from "./ModalRating.vue?vue&type=template&id=ad5d862c&scoped=true"
import script from "./ModalRating.vue?vue&type=script&lang=js"
export * from "./ModalRating.vue?vue&type=script&lang=js"

import "./ModalRating.vue?vue&type=style&index=0&id=ad5d862c&scoped=true&lang=css"

import exportComponent from "/Users/thuyninh/Sites/yamaha_lms_fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad5d862c"]])

export default __exports__